import { useValue } from "@legendapp/state/react";
import { Icon } from "@repo/ui/components/icon";
import { Avatar, AvatarFallback, AvatarImage } from "@repo/ui/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@repo/ui/ui/dropdown-menu";
import { Link } from "@tanstack/react-router";

import { user$ } from "~/stores/auth";

export const UserHeader = () => {
  const name = useValue(user$.name);
  const email = useValue(user$.email);
  const image = useValue(user$.image);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Avatar className="ml-0.5 size-7 rounded-full">
          {image && <AvatarImage src={image} alt={name} />}
          <AvatarFallback>{name?.charAt(0)}</AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-56"
        side="top"
        align="start"
        sideOffset={8}
      >
        <DropdownMenuGroup>
          <DropdownMenuLabel className="font-normal">
            <div className="flex items-center gap-2">
              <Avatar className="size-8">
                {image && <AvatarImage src={image} alt={name} />}
                <AvatarFallback>{name?.charAt(0)}</AvatarFallback>
              </Avatar>
              <div className="flex flex-col space-y-1">
                <p className="font-medium text-foreground text-sm leading-none">
                  {name}
                </p>
                <p className="text-muted-foreground text-xs leading-none">
                  {email}
                </p>
              </div>
            </div>
          </DropdownMenuLabel>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem
            render={(props) => (
              <Link {...props} to="/settings">
                <Icon name="person-circle" />
                Account settings
              </Link>
            )}
          />
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          render={(props) => (
            <Link {...props} to="/logout" preload={false}>
              <Icon name="arrow-right-bracket" />
              Log out
            </Link>
          )}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
